<template>
  <div>
    <toggle-collapse>
      <b-card style="position: relative" :title="$t('Filter Plans')">
        <b-row class="mt-2">
          <b-col sm="12" md="6">
            <b-form-group :label="$t('Owners')" label-for="vi-devices-id">
              <v-select multiple :close-on-select="false" v-model="request.owners"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                :options="[...owners]" :reduce="d => d.id"
                v-on:input="reFilterPlans('owners', Object.assign(request)), refilterContractByOwner(request.owners)" />
              <small v-if="errors && ('owners' in errors)" class="text-danger">
                {{ $t(errors['owners'][0]) }}
              </small>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6">
            <b-form-group :label="$t('contracts')" label-for="vi-devices-id">
              <v-select multiple :close-on-select="false" v-model="request.contracts"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                :options="[...contracts]" :reduce="d => d.id" v-on:input="reFilterPlans('contracts', request)" />
              <small v-if="errors && ('contracts' in errors)" class="text-danger">
                {{ $t(errors['contracts'][0]) }}
              </small>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>

    </toggle-collapse>

    <!-- form report -->
    <b-card style="position: relative" :title="$t('Select Plan & Time')">
      <div v-if="loading" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>
      <b-form @submit.prevent="getReport" class="">
        <b-row class="mt-2">
          <b-col :cols="report_type == 'report' ? 6 : 12">
            <b-form-group :label="$t('plans')" label-for="vi-plan-id">
              <v-select multiple :close-on-select="false" v-model="request.plans"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                :options="[{ name: $t('all'), id: 'all' }, ...plans]" :reduce="d => d.id" />
              <small v-if="errors && ('plans' in errors)" class="text-danger">
                {{ $t(errors['plans'][0]) }}
              </small>
            </b-form-group>
          </b-col>

          <b-col v-if="report_type == 'report'" md="6" sm="6">
            <!-- report range date -->
            <b-form-group :label="$t('Select Start Date To End Date')" label-for="report-date" :state="null">
              <flat-pickr v-model="rangeDate" :state="null" class="form-control" :config="{ ...pickerOptions }"
                placeholder="" />

              <b-form-invalid-feedback v-if="errors && (('from' in errors) || ('to' in errors))"
                :state="errors && (('from' in errors) || ('to' in errors)) ? false : null">
                {{ ('from' in errors) ? errors['from'][0] : '' }}
                {{ ('to' in errors) ? errors['to'][0] : '' }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          
          <b-col :cols="report_type == 'report' ? 6 : 12">
            <br />
            <!-- <b-form-checkbox v-model="gropByWeek" :value=true class="custom-control-secondary">
              {{$t('Get Report Grouped by Week')}}
            </b-form-checkbox> -->
            <div class="demo-inline-spacing">
              <b-form-radio v-model="request.period" name="some-radio9" value="daily" class="custom-control-primary">
                {{ $t('Daily') }}
              </b-form-radio>
              <b-form-radio v-model="request.period" name="some-radio9" value="weekly " class="custom-control-secondary">
                {{ $t('Weekly') }}
              </b-form-radio>
              <b-form-radio v-model="request.period" name="some-radio9" value="monthly" class="custom-control-success">
                {{ $t('Monthly') }}
              </b-form-radio>
              <b-form-radio v-model="request.period" name="some-radio9" value="quarterly" class="custom-control-danger">
                {{ $t('Quarterly') }}
              </b-form-radio>
              <b-form-radio v-model="request.period" name="some-radio9" value="yearly" class="custom-control-warning">
                {{ $t('Yearly') }}
              </b-form-radio>

            </div>

          </b-col>
      
          <b-col v-if="request.period=='daily'" :cols="report_type == 'report' ? 6 : 12">
            <b-form-group :label="$t('work days')" label-for="work_days" :state="null">
              <b-form-checkbox-group v-model="request.workDays" :options="daysOptions.map(d=>({value:d.value,text:$t(d.text)}))" name="flavour-1a">
              </b-form-checkbox-group>
              <b-form-invalid-feedback v-if="errors && ('workDays' in errors)"
                :state="errors && ('workDays' in errors) ? false : null">
                {{ errors.workDays[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

        </b-row>
        <b-row class="mt-2">
          <!-- reset and submit -->
          <b-col v-if="report_type == 'report'" cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
              {{ $t('Get Report') }}
            </b-button>
          </b-col>

          <b-col v-if="report_type == 'setting'" cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="button" variant="primary" class="mr-1"
              @click="saveDialySetting('garden')">
              {{ $t('Save Setings') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
    <div v-if="report_data">

      <DataTable :report_data="report_data" :report_fields="report_fields"
        :filter_included_fields="filter_included_fields" :request="request" :errors="errors"
        :loading="dataTableloading || loading" :getReport="getReport" :total="total" :from="from" :to="to"
        :sortData="sortData" />

    </div>



  </div>
</template>

<script>

import {
  BButton, BTable, BFormInvalidFeedback, BCard, BCol, BFormCheckboxGroup,
  BForm, BFormCheckbox, BFormRadioGroup, BFormGroup, BFormInput, BPagination,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText, VBTooltip,
  BInputGroupAppend, BFormRadio
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import { ref, onMounted, watch } from '@vue/composition-api'
import gardenReportLogic from '@/app/reports/garden/logic'


import {
  createFrame, createjsPDFInstance, createTable
} from '@/share/reports/pdfCommonFunctions'


import reportForm from '@/app/reports/garden/reportForm'
import ToggleCollapse from '@/views/ui/toggle-collapse/ToggleCollapse.vue'
import DataTable from '@/views/reports/data-table/DataTable.vue'

import { ReportSetting } from '@/views/reports/ReportSettings'


import ReportOptions from '@/views/reports/components/options.js'


export default {
  name: 'GardenReport',
  components: {
    BRow,
    BCard, BFormCheckboxGroup, BTable, BPagination,
    BCol, BFormRadioGroup, BFormInvalidFeedback,
    BAlert,
    BFormGroup,
    BFormInput, flatPickr,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner, BInputGroupAppend,
    ToggleCollapse,
    DataTable, BFormRadio
  },
  directives: {
    Ripple, 'b-tooltip': VBTooltip,
  },
  props: {
    report_type: {
      type: String,
      default: 'report'

    }
  },

  setup(props, { root }) {


    const tableRef = ref(null)
    const rangeDate = ref('')
    const gropByWeek = ref(false)



    const { fills, owners, contracts, plans, reFilterPlans, refilterContractByOwner } = reportForm()
    const { report_data, request, errors, loading, dataTableloading, getReport, total, from, to, isSortDirDesc, sortBy } = gardenReportLogic()

    const filter_included_fields = ['id', 'device', 'date', 'period', 'plan', 'area', 'times', 'durations', 'serveCount', 'percent', 'owner', 'contract']
    const { pickerOptions } = ReportOptions(request.value)



    const sortData = (data) => {
      sortBy.value = data.sortBy
      isSortDirDesc.value = data.isSortDirDesc
    }
    watch([plans], () => {

      request.value.page = 1
      //  console.log('plans changed')
    })
    const report_fields = [
      {
        key: 'index',
        label: 'id',

      },
      {
        key: 'owner',
        label: 'owner',
        sortable: true

      },
      {
        key: 'contract',
        label: 'contract',
        sortable: true
      },

      {
        key: 'device',
        label: 'device',
        sortable: true
      },
      {
        key: 'plan',
        label: 'plan',
        sortable: true
      },
      {
        key: 'area',
        label: 'area',
        sortable: true
      },
      {
        key: 'date',
        label: 'date',
        sortable: true
      },
      {
        key: 'period',
        label: 'Period',
        sortable: true
      },


      {
        key: 'planCount',
        label: 'plan count',
        sortable: true

      },

      {
        key: 'planServeCount',
        label: 'plan serve count',
        sortable: true

      },

      {
        key:'outOfPlan',
        label:'Out Of Plan numbers',
        sortable:true
      },
     
      {
        key: 'totalCount',
        label: 'total services',
        sortable: false
      },

      {
        key: 'times',
        label: 'times',
        sortable: true
      },
      {
        key: 'durations',
        label: 'durations',
        sortable: true
      },
    

      {
        key: 'percent',
        label: 'percent',
        sortable: true
      },
      


    ]


    const daysOptions = [
      { text: 'Saturday', value: 'Saturday' },
      { text: 'Sunday', value: 'Sunday' },
      { text: 'Monday', value: 'Monday' },
      { text: 'Tuesday', value: 'Tuesday' },
      { text:'Wednesday', value: 'Wednesday' },
      { text: 'Thursday', value: 'Thursday' },
      { text: 'Friday', value: 'Friday' },
    ]

    const groupByOptions = [
      { text: 'Device', value: 'device' },
      { text: 'Day', value: 'day' },
    ]

    const reportMethodsOptions = [
      { text: 'Weight', value: 'weight' },
      { text: 'Area Enter/Exit', value: 'enterOrExit' },
    ]



    const report_wrapper = ref(null)

    watch(gropByWeek, () => {
      if (gropByWeek.value == true) {
        Object.assign(request.value, { groupBy: "week" })
      } else {

        delete request.value.groupBy;
      }
    })






    /// here use root form ass dialy report setting

    const toaster = (msg, variant, title) => {
      root.$root.$bvToast.toast(msg, {
        title,
        variant,
        solid: true,
      })
    }
    const saveDialySetting = (reportName) => {
      let setting_data = request.value;
      delete setting_data.to;
      delete setting_data.from;

      ReportSetting.setSettings(reportName, setting_data).then((res) => {
        toaster(root.$root.$t('settigs saved succeffly!!'), 'scuccess', root.$root.$t('success!!'))
      })

        .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
    }
    onMounted(() => {
      if (props.report_type == "setting") {
        ReportSetting.getSetting('gardenPlan').then((res) => {

          request.value = res;
        })
      }
    })
    //here end of   dialy report setting
    return {
      report_data, report_fields, filter_included_fields, total, from, to, rangeDate,
      tableRef,
      getReport,



      fills,


      pickerOptions,
      report_wrapper,


      groupByOptions,

      daysOptions,
      reportMethodsOptions,
      request,
      loading,
      dataTableloading,
      errors,

      owners, contracts, plans,
      reFilterPlans,
      refilterContractByOwner,

      // filter,
      // filterOn,
      gardenReportLogic,
      //dialy report setting
      saveDialySetting,

      gropByWeek,


      sortBy, isSortDirDesc, sortData
    }

  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}

.group-row {
  background-color: #ddd;
}
</style>
